import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import styles from './Disclaimers.module.scss';

export const Disclaimers = ({
  title,
  paragraph,
  dispatch,
  dependencyChange,
}) => {
  const list = paragraph.field_text;
  const elements = 'h1, h2, h3, h4, h5, h6, p, span, li';
  const lookup = {
    '¹': 0,
    '²': 1,
    '³': 2,
    '⁴': 3,
    '⁵': 4,
    '⁶': 5,
    '⁷': 6,
    '⁸': 7,
    '⁹': 8,
  };
  const attribute = 'disclaimer';

  // handlers/helpers
  const toggleMessage = e => {
    const message = e ? e.target.dataset[attribute] : '';
    const visibility = e ? true : false;
    dispatch.message(visibility, { description: message }, 'disclaimer');
  };
  const augmentSuperscripts = () => {
    document.querySelectorAll(elements).forEach(a => {
      const notThisComponent = a.classList.value.indexOf(styles.paragraph) < 0;
      const superscripts = [...new Set(a.textContent.match(/[⁰¹²³⁴⁵⁶⁷⁸⁹]/g))];
      const hasNoChildren = a.children.length < 2;
      if (notThisComponent && superscripts && hasNoChildren)
        superscripts.map(i => {
          const text = Object.keys(list).length > 1 ? list[lookup[i]] : list[0];
          const html = `<span data-${attribute}="${text}">${i}</span>`;
          a.innerHTML = a.innerHTML.replace(`/${i}/g`, html);
        });
    });
  };
  const attachListeners = () => {
    document.querySelectorAll(`[data-${attribute}]`).forEach(a => {
      a.addEventListener('click', toggleMessage);
    });
  };
  const addReferenceInteraction = () => {
    augmentSuperscripts();
    attachListeners();
  };

  // useEffect runs after DOM mutations are painted
  useEffect(() => {
    addReferenceInteraction();
  }, [dependencyChange]);

  //
  return (
    <section className={styles.container}>
      <h2 className="sr-only">{title}</h2>

      {paragraph.field_text.map((text, index) => (
        <p className={styles.paragraph} key={index}>
          {text}
        </p>
      ))}
    </section>
  );
};

Disclaimers.propTypes = {
  title: PropTypes.string,
  paragraph: PropTypes.shape({
    drupal_id: PropTypes.string.isRequired,
    field_text: PropTypes.arrayOf(PropTypes.string).isRequired,
  }).isRequired,
  dependencyChange: PropTypes.number,
};
Disclaimers.defaultProps = {
  dependencyChange: null,
};
